@if (isEditing) {
  <dx-text-box
    [(value)]="value"
    type="text"
    appFilterInput
    (focusout)="onFocusOut()"
    #editInput
    >
  </dx-text-box>
}
@if (!isEditing) {
  <dx-text-box
    type="text"
    [(value)]="displayValue"
    (focusin)="onFocusIn()"
    >
  </dx-text-box>
}
